angular.module('login.index', [
	'ngRoute',
	'config',
	'security.service',
	'directives.serverError',
	'services.utility',
	'ui.bootstrap',
	'services.localizedMessages'
]);

angular.module('login.index').config(["$stateProvider", function ($stateProvider) {
	$stateProvider
		.state('login', {
			url: '/login',
			views: {
				header: {
					template: require('../common/header/header.tpl.html'),
					controller: 'HeaderCtrl'
				},
				main: {
					template: require('./login.tpl.html'),
					controller: 'LoginCtrl',
					title: 'Login'
				},
				footer: {
					template: require('../common/footer/footer.tpl.html'),
					controller: 'FooterCtrl'
				}
			},
			resolve: {
				user: ["User", "$q", "$timeout", "$state", function (User, $q, $timeout, $state) {
					return User.current(function (user) {
						if (user._id) {
							$timeout(function () {
								$state.go('account')
							})
							return $q.reject()
						}
						return user
					}).$promise;
				}],
			},
		});
}]);

angular.module('login.index').controller('LoginCtrl', ['$scope', '$location', '$log', 'security', 'utility', 'SOCIAL', 'localizedMessages',
	function ($scope, $location, $log, security, utility, SOCIAL, localizedMessages) {
		$scope.localizedMessages = localizedMessages;

		// local variable
		var loginSuccess = function (data) {
			if (data) {
				//account/user created, redirect...
				return $location.path('/account/my-articles');
			}
			else {
				//error due to server side validation
				$scope.errfor = data.errfor;
				angular.forEach(data.errfor, function (err, field) {
					$scope.loginForm[field].$setValidity('server', false);
				});
				angular.forEach(data.errors, function (err, index) {
					$scope.alerts.push({
						type: 'danger',
						msg: err
					});
				});
			}
		};
		var loginError = function (err) {
			console.log(err);
			$scope.alerts.push({
				type: 'danger',
				msg: err.data.message
			});
		};
		// model def
		$scope.user = {};
		$scope.alerts = [];
		if ($location.$$search.verified && $location.$$search.verified == "true") {
			$scope.alerts.push({
				type: 'success',
				msg: "Verification successful, you can enter usig your username and password."
			});
		} else if ($location.$$search.verified && $location.$$search.verified == "false") {
			$scope.alerts.push({
				type: 'danger',
				msg: "Unsuccessful verification."
			});
		}

		if ($location.$$search.mailSent) {
			$scope.alerts.push({
				type: 'success',
				msg: "Verification link sent to email you specified."
			});
		}
		$scope.errfor = {};
		$scope.social = angular.equals({}, SOCIAL) ? null : SOCIAL;

		// method def
		$scope.hasError = utility.hasError;
		$scope.showError = utility.showError;
		$scope.canSave = utility.canSave;
		$scope.closeAlert = function (ind) {
			$scope.alerts.splice(ind, 1);
		};
		$scope.submit = function () {
			$scope.alerts = [];
			security.login($scope.user.username, $scope.user.password).then(loginSuccess, loginError);
		};
	}]);



// WEBPACK FOOTER //
// ./client/src/app/login/login.js